import { render, staticRenderFns } from "./ListaItensPaginacao.vue?vue&type=template&id=0c5e9d68&scoped=true"
import script from "./ListaItensPaginacao.vue?vue&type=script&lang=js"
export * from "./ListaItensPaginacao.vue?vue&type=script&lang=js"
import style0 from "./ListaItensPaginacao.vue?vue&type=style&index=0&id=0c5e9d68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5e9d68",
  null
  
)

export default component.exports